var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgViewAgenda = function SvgViewAgenda(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#view_agenda_svg__clip0_157_5922)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15.833 4.167V7.5h-12.5V4.167zm0 8.333v3.333h-12.5V12.5zm.834-10H2.5a.836.836 0 0 0-.833.833v5c0 .459.375.834.833.834h14.167a.836.836 0 0 0 .833-.834v-5a.836.836 0 0 0-.833-.833m0 8.333H2.5a.836.836 0 0 0-.833.834v5c0 .458.375.833.833.833h14.167a.836.836 0 0 0 .833-.833v-5a.836.836 0 0 0-.833-.834"
  }))));
};
export default SvgViewAgenda;